export function enterpriseMembersReducer(state, action) {
  switch (action.type) {
    case "loadMembers":
      return {
        ...state,
        members: action.members,
      };
    case "showCredits":
      return {
        ...state,
        showCredits: true,
        currentMember: action.member,
      };
    case "hideCredits":
      return {
        ...state,
        showCredits: false,
        currentMember: null,
      };
    case "deleteMember":
      return {
        ...state,
        members: state.members.filter(
          (item) => parseInt(item.id) != parseInt(action.memberId)
        ),
      };
    default:
      throw new Error();
  }
}
